import { config } from '@/utils/config';
/**
 * Mixin linków renderera
 * Zawiera metody:
 *  - `getPreviewURL(documentId, viewId)` - zwraca link podglądu dokumentu
 *  - `getPdfURL(documentId, viewId)` - zwraca link pobierania dokumentu
 *  - `getZipUrl(documentId, viewId)` - zwraca link pobrania paczki zip
 */
export const renderMixin = {
  methods: {
    /**
     * zwraca link podglądu dokumentu
     *
     * @param {*} documentId
     * @param {*} viewId
     * @param {*} extraViewIds
     * @returns
     */
    getPreviewURL(documentId, viewId, extraViewIds) {
      if (!extraViewIds) {
        return `${config.renderURL}/preview/document/${documentId}/${viewId}`;
      }

      const query = this.prepareMultipleQuery(viewId, extraViewIds);
      return `${config.renderURL}/preview-multiple/document/${documentId}?${query}`;
    },

    /**
     * zwraca link pobierania dokumentu
     *
     * @param {*} documentId
     * @param {*} viewId
     * @param {*} extraViewIds
     * @param {*} landscape
     * @returns
     */
    getPdfURL(documentId, viewId, extraViewIds, landscape) {
      landscape = landscape || false;
      if (!extraViewIds) {
        return `${config.renderURL}/pdf/document/${documentId}/${viewId}?landscape=${landscape}`;
      }

      const query = this.prepareMultipleQuery(viewId, extraViewIds);
      return `${config.renderURL}/pdf-multiple/document/${documentId}?${query}&landscape=${landscape}`;
    },

    /**
     * Przygotowuje query-parametry do generowania wielu widoków
     *
     * @param {*} viewId
     * @param {*} extraViewIds
     * @returns
     */
    prepareMultipleQuery(viewId, extraViewIds) {
      return [viewId, ...extraViewIds].map(id => `viewIds=${id}`).join('&');
    },

    /**
     * zwraca link do pobrania PDF z przesłanego HTML'a
     *
     * @param {*} documentId
     * @param {*} viewId
     * @returns
     */
    getPdfFromHtmlUrl(viewId) {
      return `${config.renderURL}/file/html/${viewId}`;
    },

    /**
     * zwraca link do pobrania zip z przesłanego HTML'a
     *
     * @param {*} documentId
     * @param {*} viewId
     * @returns
     */
    getZipURL(documentId, viewId) {
      return `${config.renderURL}/zip/document/${documentId}/${viewId}`;
    }
  }
};
